import type { LinkageRule } from '../../../../platform/linkage/types';

export interface NetworkContextLinkageProps {
  workspace?: string;
  datacenter?: string;
}

export interface StorageContextLinkageProps {
  namespace?: string;
  containerName?: string;
  datacenter?: string;
}

export function createNetworkContextLinkageRules<TPropsMap extends Record<string, unknown>>(): LinkageRule<TPropsMap>[] {
  return [
    {
      id: 'baseInfo.networkContext',
      watch: ['workspace', 'datacenter'],
      target: 'network' as keyof TPropsMap & string,
      derive: ({ values }) =>
        ({
          workspace: values.workspace as string | undefined,
          datacenter: values.datacenter as string | undefined,
        }) as unknown as Partial<TPropsMap[keyof TPropsMap]>,
    },
  ];
}

export function createStorageContextLinkageRules<TPropsMap extends Record<string, unknown>>(
  targets: ('storage' | 'container-storage')[],
): LinkageRule<TPropsMap>[] {
  const derive = ({ values }: { values: Record<string, unknown> }) =>
    ({
      namespace: values.namespace as string | undefined,
      containerName: values.name as string | undefined,
      datacenter: values.datacenter as string | undefined,
    }) as unknown as Partial<TPropsMap[keyof TPropsMap]>;

  return targets.map((target) => ({
    id: `baseInfo.${target}Context`,
    watch: ['namespace', 'name', 'datacenter'],
    target: target as keyof TPropsMap & string,
    derive,
  }));
}
